<template>
  <MarketplaceForm :item="item" :default-item-data="item_data" :new-store-fn="newStoreOzon" :edit-store-fn="editStoreOzon" @storeSuccess="$emit('storeSuccess')">
    <template #top>
      <div class="col mb-3">
        <DocLink docKey="marketplace_ozon" text="Посмотреть инструкцию по подключению Озон" />
      </div>
    </template>
    
    <template #connection="{item_data}">
      <div v-if="item_data.connection.connection_type !== 'oauth'" class="col mb-4">
        <label class="form-label">Client ID</label>
        <input type="text" name="connection[client_id]" class="form-control" placeholder="" required
               v-model="item_data.connection.client_id">
      </div>
      <div v-if="item_data.connection.connection_type !== 'oauth'" class="col mb-4">
        <label class="form-label">API Key</label>
        <div class="input-group">
          <input :type="apiKeyVisible ? 'text' : 'password'" name="connection[api_key]" class="form-control" placeholder="" required
                 v-model="item_data.connection.api_key">
          <span class="input-group-text cursor-pointer" @click="toggleApiKeyVisibility">
            <i class="ti" :class="apiKeyVisible ? 'ti-eye-off' : 'ti-eye'"></i>
          </span>
        </div>
      </div>
    </template>
    <template #settings="{item_data}">
      <div class="col mb-4">
        <label class="form-label">Способ расчета стоимости логистики</label>
        <Select
          v-model="item_data.settings.logistics_method"
          :options="logisticsMethodOptions"
          optionLabel="label"
          optionValue="value"
          class="w-100"
        />
      </div>
    </template>
  </MarketplaceForm>
</template>
<script>
import {newStoreOzon, editStoreOzon} from "@/api/store";
import MarketplaceForm from "@/components/forms/MarketplaceForm.vue";
import Select from "primevue/select";
import DocLink from "@/components/tools/DocLink.vue";

export default {
  name: "OzonForm",
  components: {MarketplaceForm, Select, DocLink},
  data() {
    return {
      logisticsMethodOptions: [
        {value: 'minimum', label: 'Минимальная стоимость'},
        {value: 'average', label: 'Среднее значение'},
        {value: 'maximum', label: 'Максимальная стоимость'},
      ],
      item_data: {
        id: '',
        name: '',
        company: '',
        marketplace: 'ozon',
        connection: {
          connection_type: null,
          client_id: '',
          api_key: '',
          oauth_account_id: null
        },
        settings: {
          model: 'fbs',
          fixed_commission: 30,
          percent_commission: 0,
          logistics_method: 'average',
        },
        schedule: {
          import_products: null,
          get_offers: [4, 16],
          get_orders: '60'
        }
      },
      apiKeyVisible: false
    }
  },
  props: ['item'],
  methods: {
    newStoreOzon, editStoreOzon,
    toggleApiKeyVisibility() {
      this.apiKeyVisible = !this.apiKeyVisible;
    }
  }
}
</script>